import React from "react";

const CharityLogo = ({ charity }) => {
  return <img src={charity.profileImagePath} className='aspect-square rounded bg-white w-full object-contain' alt={`${charity.name} Logo`} />;
};

export default CharityLogo;
